
  import { Vue, Component, Prop } from "vue-property-decorator";

  import { User, Company, Manager } from "@/generated/graphql"
  import Roles from "@/entities/Roles";
  import RouteNames from "@/entities/RouteNames";
  import NotFoundPage from "@/components/common/NotFoundPage.vue";
  import GET_MARKETPLACE_ACCESS from "@/apollo/managers/GetMarketplaceAccess.gql";
  import CompanyMarketplaceAccessType from "@/entities/CompanyMarketplaceAccessType";

  @Component({
    components: {
      NotFoundPage,
    },
    apollo: {
      $subscribe: {
        manager: {
          query: GET_MARKETPLACE_ACCESS,
          variables() {
            return {
              managerId: this.managerId,
            };
          },
          skip() {
            return !this.isManager
          },
          result(response: any) {
            this.manager = response.data.manager_by_pk;
          },
        },
      },
    },
  })
  export default class DisabledPagesGuard extends Vue {
    @Prop({ type: Object, required: true }) readonly currentUser!: User;
    @Prop({ type: Object, default: undefined }) readonly company!: Company;

    manager: Manager | null = null;

    get user(): User {
      if (!this.isManager) {
        return this.currentUser;
      }

      if (!this.manager) {
        return this.currentUser;
      }

      const {
        marketplace_access_requested,
        marketplace_access_allowed,
        company,
      } = this.manager!;

      const { marketplace_access_type } = company;

      return {
        ...this.currentUser,
        manager: {
          ...this.currentUser.manager!,
          marketplace_access_requested,
          marketplace_access_allowed,
          company: {
            ...this.company,
            marketplace_access_type,
          }
        }
      };
    }

    get managerId(): string | undefined {
      return this.currentUser.manager?.id;
    }

    get isManager(): boolean {
      return this.currentUser.role === Roles.MANAGER;
    }

    get isCurrentRouteDisabled(): boolean {
      if (!this.isManager) {
        return false;
      }

      if (this.company!.marketplace_access_type === CompanyMarketplaceAccessType.ALL) {
        return false;
      }

      const marketplaceRoute = this.$route.name === RouteNames.MARKETPLACE_CONTRACTORS;
      const selectiveAccess = this.company!.marketplace_access_type === CompanyMarketplaceAccessType.SELECTED;
      const accessAllowed = this.currentUser.manager!.marketplace_access_allowed;

      return !(selectiveAccess && accessAllowed) && marketplaceRoute;
    }
  }
